import { MenuData } from './../../communication-structure/menu-button-data';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as XLSX from '../../../xlsx';
import { APIRequestOptions } from '../../communication-structure/api-request';
import { CommunicationProxyService } from '../../services/communication-proxy.service';
import { LoginService } from '../../services/login.service';
import { SheetjsHelperService } from '../../services/sheetjs-helper.service';
import { StringTableService } from '../../services/string-table.service';
import { MainComponent } from '../main-component/main.component';
import { PageViewComponent } from '../page-view/page-view.component';
import { Table, Types } from '../table/table.component';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent extends PageViewComponent implements OnInit {
  skillEmptyText: string;
  detailsHeader: any[];
  @Input() itemValueDashboard: number;
  @Input() pieChartType = 0;
  @Input() popupData: any;
  @Output() closeButtonClicked: EventEmitter<object> = new EventEmitter();
  @ViewChild('popupTable') popupTable;
  @ViewChild('navigationLabel') navLabel: ElementRef;
  @ViewChild('tableContainer') tableContainer: ElementRef;
  currentSkillNumber = 1;
  currentSkill = { skillId:"demo", skillName:"", applicationName: "Word", src: "http://abc.com" };
  maxskill = 0;
  isExcelDownloadInProgress = false;
  isPdfDownloadInProgress = false;
  private primaryTableHeaders = [];
  private secondaryTableHeaders = [];

  table = [];
  header = [];
  popupTitle = '';
  tableTitle = '';
  skillNavigationArray = [];
  menuData: MenuData;
  popupTableData;
  private pdfFilename: string;
  private xlsxFilename: string;
  private headerColor: any;
  private xlsxWritingOptions: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };

  constructor(
    ele: ElementRef,
    protected remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    protected stringTableService: StringTableService,
    private sheetjsHelper: SheetjsHelperService,
    protected router: Router) {
    super(ele, remoteProxy, loginService, stringTableService, router);
  }

  ngOnInit() {
    this.initView();
  }
  initView() {
    this.primaryTableHeaders = this.stringTableService.getArrayOfStrings('popups', 'primaryTableHeaders');
    this.secondaryTableHeaders = this.stringTableService.getArrayOfStrings('popups', 'secondaryTableHeaders');
    this.accessIconPath = this.stringTableService.getString('paths', 'accessLogo');
    this.excelIconPath = this.stringTableService.getString('paths', 'excelLogo');
    this.wordIconPath = this.stringTableService.getString('paths', 'wordLogo');
    this.outlookIconPath = this.stringTableService.getString('paths', 'outlookLogo');
    this.powerpointIconPath = this.stringTableService.getString('paths', 'powerpointLogo');
    this.skillEmptyText = this.stringTableService.getString('popups', 'SkillEmptyText');
    this.header = this.setTableHeaders(this.primaryTableHeaders);
    this.pdfFilename = this.stringTableService.getString('popups', 'pdfFilename');
    this.xlsxFilename = this.stringTableService.getString('popups', 'xlsxFileName');
    this.headerColor = this.stringTableService.getString('popups', 'headerColor');
    this.detailsHeader = this.setTableHeaders(this.secondaryTableHeaders);
    this.setPopupTitle();
    this.setTableTitle();
    this.setNavigationSkill();
    this.getSkillData();
    this.setPopupTableData();
    this.setUserEmail();
    this.setMenuData();
  }
  setMenuData() {
    this.menuData = {
      menuId: 'list-menu-pop-up',
      buttonClass: 'tg-list-icon',
      options: new Array()
    };
    this.skillNavigationArray.forEach((skill, index) => {
      const option = {
        id: index,
        name: skill.skillName
      };
      this.menuData.options.push(option);
    });
  }

  setUserEmail() {
    this.userEmailId = this.popupData.candidateEmail;
  }

  setTableHeaders(data) {
    const headerArray = [];
    for (const header of data) {
      const headerData = {
        title: header,
        type: 0,
        class: 'table-header'
      };
      headerArray.push(headerData);
    }
    return headerArray;
  }
  setPopupTitle() {
    this.popupTitle = this.popupData.autoTrainingCodeName;
  }

  setTableTitle() {
    this.tableTitle = this.popupData.desc;
  }

  setNavigationSkill() {
    for (const skill of this.popupData.skillList) {
      const path = this.getApplicationIconPath(skill.applicationName);
      const selectedSkill = {
        skillId: skill.skillId,
        skillName: skill.skillName,
        applicationName: skill.applicationName,
        src: path
      };
      this.skillNavigationArray.push(selectedSkill);
    }
    this.currentSkillNumber = 1;
    this.currentSkill = this.skillNavigationArray[this.currentSkillNumber - 1];
    this.maxskill = this.skillNavigationArray.length;
  }

  onCloseButtonClick(event) {
    this.closeButtonClicked.emit(event);
  }

  loadPreviousSkill(event) {
    if (this.currentSkillNumber !== 1) {
      this.currentSkillNumber--;
    }
    if (this.currentSkillNumber === 1) {
      this.ele.nativeElement.getElementsByClassName('close')[0].focus();
    }
    this.currentSkill = this.skillNavigationArray[this.currentSkillNumber - 1];
    this.getSkillData();
    this.setPopupTableData();
    if (this.popupTable) {
      this.popupTable.generateEmptySubTableList(200);
      this.popupTable.updatePopupTableData(this.popupTableData);
      this.popupTable.updateDownloadState();
    }
  }

  loadNextSkill(event) {
    if (this.currentSkillNumber !== this.maxskill) {
      this.currentSkillNumber++;
    }
    if (this.currentSkillNumber === this.maxskill) {
      this.ele.nativeElement.getElementsByClassName('close')[0].focus();
    }
    this.currentSkill = this.skillNavigationArray[this.currentSkillNumber - 1];
    this.getSkillData();
    this.setPopupTableData();
    if (this.popupTable) {
      this.popupTable.generateEmptySubTableList(200);
      this.popupTable.updatePopupTableData(this.popupTableData);
      this.popupTable.updateDownloadState();
    }
  }

  getSkillData() {
    const applicationId = this.popupData.applicationid ? this.popupData.applicationid : this.popupData.applicationId;
    this.getApplicantTrainingResult(applicationId, this.skillNavigationArray[this.currentSkillNumber - 1].skillId);
  }

  isTableShow() {
    if (this.popupData.skillList[this.currentSkillNumber - 1].attempts > 0) {
      return true;
    } else {
      return false;
    }
  }

  saveGlobalReportToXls(): void {
    this.isExcelDownloadInProgress = true;
    const skillIdList = [];

    this.popupData.skillList.forEach(skill => {
      skillIdList.push( skill.skillId );
    });

    const requestData = JSON.stringify({
      applicationId: this.popupData.applicationid ? this.popupData.applicationid : this.popupData.applicationId,
      skillIdList: skillIdList,
    });

    this.remoteProxy.sendPostRequest(this.skillResultEndPoint, requestData).subscribe( ( response ) => {
      this.generateExcelReport( response );
      this.isExcelDownloadInProgress = false;
    });
  }

  generateExcelReport( response ) {
    const subTablesData = this.prepareSubTables( response );
    const workSheets = [];
    const titles = [];

    subTablesData.forEach( (subtable) => {
      const worksheet = this.generateWorkSheet( subtable );

      if ( worksheet ) {
        workSheets.push( worksheet );
      }
    } );

    response.trainingResultList.forEach( result => {
      titles.push( result.skillName );
    } );

    const workBook = this.sheetjsHelper.prepareWorkBook( workSheets, this.headerColor, titles );
    this.sheetjsHelper.downloadSheet(workBook, this.xlsxWritingOptions, this.xlsxFilename);
  }

  generateWorkSheet( subTableData ) {
    if ( subTableData.length === 1 ) {
      const data = this.sheetjsHelper.parseDataForSheetJs([subTableData], 1);
      return this.sheetjsHelper.prepareSheet(data, 1);
    }

    const table: Table[][] = this.generateSubtable( subTableData[9].title );
    const headerClone = JSON.parse(JSON.stringify(this.detailsHeader));

    headerClone.forEach( (header) => {
      header.title = header.title.name;
    } );

    const noOfColumns = headerClone.length;
    const dataForSheetJs = this.sheetjsHelper.parseDataForSheetJs([headerClone], noOfColumns);
    let tableRowsForExcel;

    if (table.length > 0) {
      if (table[0][4].type === 13) {
        tableRowsForExcel = this.convertTableArrayIntoString(table);
      }

      dataForSheetJs.splice(1, dataForSheetJs.length);
      const tableClone = JSON.parse(JSON.stringify(tableRowsForExcel));
      Array.prototype.push.apply(dataForSheetJs, this.sheetjsHelper.parseDataForSheetJs(tableClone, noOfColumns));

      return this.sheetjsHelper.prepareSheet(dataForSheetJs, noOfColumns);
    } else {
      return null;
    }
  }

  prepareSubTables( response ) {
    const displayedTables = [];

    response.trainingResultList.forEach( ( result ) => {
      const attemptList = this.getAttemptListBySkillId( result, result.skillId );
      const testId = this.attemptlist.length > 0 && result.skillAttemptList.length > 0 ? result.skillAttemptList[0].testSessionCode : '';

      attemptList.forEach( ( attempt, index ) => {
        displayedTables.push(this.generateDisplayTable( index + 1, testId, attempt, {}));
      });

      if ( attemptList.length === 0 ) {
        displayedTables.push( [ new Table(Types.TEXT, 'table-data', this.skillEmptyText) ] );
      }
    });

    return displayedTables;
  }

  saveGlobalReportToPdf(): void {
    this.isPdfDownloadInProgress = true;
    const skillList = [];
    let taskList = [];

    this.popupData.skillList.forEach(skill => {
      const skillTasks = MainComponent.getTrainingList().find(record => record.skillId === skill.skillId).taskList;
      taskList = taskList.concat( skillTasks );

      skillList.push( {
        skillId: skill.skillId,
        applicationName: skill.applicationName
      });
    });

    taskList.forEach( task => {
      delete task.taskId;
    });

    const data = JSON.stringify({
      applicationId: this.popupData.applicationid ? this.popupData.applicationid : this.popupData.applicationId,
      skillList: skillList,
      taskList: taskList
    });

    const requestOptions: APIRequestOptions = {
      responseType: 'blob'
    };

    this.remoteProxy.sendPostRequest( this.generatePdfReportEndPoint, data, requestOptions)
    .subscribe((response) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      saveAs(blob, this.pdfFilename);
      this.isPdfDownloadInProgress = false;
    }, (error) => {
      console.log(error);
    });
  }

  setPopupTableData() {
    this.popupTableData = {
      applicationid: this.popupData.applicationid ? this.popupData.applicationid : this.popupData.applicationId,
      skillList: [ this.currentSkill ],
      autoTrainingCodeName: this.popupData.autoTrainingCodeName
    };
  }

  generateSubtable(subtable) {
    let index = 0;
    const detailTable = [];

    for (const tasklistTable of subtable) {
      detailTable.push([
        new Table(Types.TEXT, 'table-data', ++index),
        new Table(Types.TEXT, 'table-data', tasklistTable.taskName),
        new Table(Types.TEXT, 'table-data', this.setQueState(tasklistTable.status)),
        new Table(Types.TEXT, 'table-data', this.convertTime(tasklistTable.timeTaken, ':')),
        new Table(Types.MINMAX_LIST, 'tg-arrow-up2', tasklistTable.clickstreams)
      ]);
    }

    return detailTable;
  }

  convertTableArrayIntoString(table) {
    const newTable = [];
    Object.assign(newTable, table);

    for (const row of newTable) {
      for (const cell of row) {
        let text = '';

        if (cell.type === 13) {
          for (const label of cell.title) {
            text = text + ' ' + label.text;
          }

          cell.title = text;
        }
      }
    }

    return newTable;
  }

  public onSelectionChange(menuItem: { id: number, name: string }): void {
    this.currentSkillNumber = menuItem.id + 1;
    this.currentSkill = this.skillNavigationArray[this.currentSkillNumber - 1];
    this.getSkillData();
    this.setPopupTableData();
    if (this.popupTable) {
      this.popupTable.generateEmptySubTableList(200);
      this.popupTable.updatePopupTableData(this.popupTableData);
      this.popupTable.updateDownloadState();
    }
  }

  public get menuWidth(): number | '' {
    return this.navLabel ? (this.navLabel.nativeElement as HTMLElement).offsetWidth : '';
  }

  public get menuHeight(): number | '' {
    return this.tableContainer ? (this.tableContainer.nativeElement as HTMLElement).offsetHeight : '';
  }
}


// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/pop-up/pop-up.component.ts